import { render, staticRenderFns } from "./reviewItems.vue?vue&type=template&id=909f96fc&scoped=true&lang=pug"
import script from "./reviewItems.vue?vue&type=script&lang=js"
export * from "./reviewItems.vue?vue&type=script&lang=js"
import style0 from "./reviewItems.vue?vue&type=style&index=0&id=909f96fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909f96fc",
  null
  
)

export default component.exports